import type { DragEvent, KeyboardEvent } from "react";
import { Badge } from "@/components/ui";
import { EVENT_TYPE_LABELS, type BoardItem } from "@/api/types/inquiry";
import { formatDate } from "./format";

interface InquiryCardProps {
  item: BoardItem;
  onOpen: () => void;
  onDragStart: (e: DragEvent<HTMLDivElement>) => void;
}

export function InquiryCard({ item, onOpen, onDragStart }: InquiryCardProps) {
  function handleKeyDown(e: KeyboardEvent<HTMLDivElement>) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onOpen();
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      draggable
      data-inquiry-id={item.id}
      onDragStart={onDragStart}
      onClick={onOpen}
      onKeyDown={handleKeyDown}
      className="cursor-grab rounded-lg border border-border bg-bg-card p-3 shadow-xs transition-[border-color,box-shadow,transform] duration-150 hover:-translate-y-0.5 hover:border-copper/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 motion-reduce:hover:translate-y-0 active:cursor-grabbing"
    >
      <p className="truncate text-sm font-semibold text-text-primary">{item.contact_name}</p>

      <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
        {item.event_date && (
          <span className="tabular text-xs text-text-muted">{formatDate(item.event_date)}</span>
        )}
        {item.event_type && (
          <Badge variant="secondary" size="sm">
            {EVENT_TYPE_LABELS[item.event_type]}
          </Badge>
        )}
      </div>

      <div className="mt-2 flex items-center justify-between gap-2">
        <span className="text-xs text-text-secondary">
          {item.guest_count != null ? `${item.guest_count} guests` : "Guests TBD"}
        </span>
        {item.sla_breached && (
          <Badge variant="danger" size="sm">
            SLA breached
          </Badge>
        )}
      </div>
    </div>
  );
}
